export const CUSTOMER_CREATE_BOOKING_TRANSITION = 'transition/customer-create-booking';
export const REQUEST_PAYMENT_AFTER_INQUIRY_TRANSITION = 'transition/request-payment-after-inquiry';

export const getCreateBookingTransition = (availableTransitionNames = []) => {
  if (availableTransitionNames.includes(CUSTOMER_CREATE_BOOKING_TRANSITION)) {
    return CUSTOMER_CREATE_BOOKING_TRANSITION;
  }

  return availableTransitionNames.includes(REQUEST_PAYMENT_AFTER_INQUIRY_TRANSITION)
    ? REQUEST_PAYMENT_AFTER_INQUIRY_TRANSITION
    : null;
};

export const getInquiryCheckoutInitialValues = (transaction, transitionParams) => {
  const selectedServiceId =
    transaction?.attributes?.protectedData?.bookingInquiry?.selectedServiceId;

  return {
    listing: transaction.listing,
    transaction,
    orderData: {
      bookingDates: {
        bookingStart: transitionParams.bookingStart,
        bookingEnd: transitionParams.bookingEnd,
      },
      ...(selectedServiceId ? { serviceId: selectedServiceId } : {}),
      ...(transitionParams.protectedData ? { protectedData: transitionParams.protectedData } : {}),
    },
    confirmPaymentError: null,
  };
};
